import React, { useCallback, useEffect, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
import Select from "react-select";
// Icons
import { Plus, ArrowLeft, SearchIcon, Factory, X } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";
import PaginationTest from "Common/Components/Paginationtest";
import TableDropDownSmall from "pages/Components/TableDropDownSmall";
import PesticideFarmerColumn from "Common/Components/ColumnData/PesticideFarmerColumn";
import FarmerInfoForModal from "Common/FarmerInfoForModal";
import PoisonFarmerModal from "Common/Components/PoisonFarmerModal/poisonFarmerModal";

const PoisonDeliveryFarmer = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  const [isEdit, setIsedit] = useState<boolean>(false);
  const [dataFactoryList, setdataFactoryList] = useState<any>([]);
  // Delete Modal

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [dataSeedList, setdataSeedList] = useState<any>([]);
  const [alldata, setalldata] = useState<Number>();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [size, setsize] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [selectedNumber, setSelectedNumber] = useState<any>(10);
  const [searchValue, setsearchValue] = useState<any>();
  const [seed_amount, setseed_amount] = useState<any>();
  const [dataSeedID, setDataSeedID] = useState<any>();
  const [commitment_idList, setcommitment_idList] = useState<any>();
  const [coomitID, setcoomitID] = useState<any>();
  const [SearchValueCommit, setsetSearchValueCommit] = useState<any>();
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();
  const localstorageID = localStorage.getItem("crop_year_id");
  const [seednameForEdit, setseednameForEdit] = useState<any>(null);
  const [idSeed, setidSeed] = useState<any>(null);
  const [isLoadingBtn, setisLoadingBtn] = useState<boolean>(false);
  const [dataFactoryID, setDataFactoryID] = useState<any>();
  const [FactorynameUpdate, setFactorynameUpdate] = useState<any>();
  const [defultcheckedPrice, setdefultcheckedPrice] = useState<any>(true);
  const [poison_Price, setpoison_Price] = useState<any>(true);
  const [FarmerNameForEdit, setFarmerNameForEdit] = useState<any>("");
  const [selectedCommitment, setselectedCommitment] = useState<any>("");
  const [sortState, setSortState] = useState<any>({
    name: null,
    order: "desc",
    step: 0,
  });
  const [searchpesticide, setsearchpesticide] = useState<any>(null);
  const [isLoadingBtnModal, setisLoadingBtnModal] = useState<any>("");
  const sortLabels: any = {
    farmer_name: "نام کشاورز",
    remaining_receivable_payable_balance: "مانده طلب / بدهی",
    price: "قیمت کشاورز",
    factory_name: "نام کارخانه",
    commitment_number: "شماره تعهد",
    pesticide_name: "اسم سم",
    pesticide_amount: "مقدار سم",
  };
  const [selectedFarmerInfo, setSelectedFarmerInfo] = useState<any>({
    amount_of_land: "",
    village_name: "",
    date_set: "",
  });
  useEffect(() => {
    const getFarmerInfo = async () => {
      try {
        setisLoadingBtnModal(true);
        const res = await axios.get(
          `https://api.havirkesht.ir/commitment/${Number(coomitID)}`, // توجه: coomitID به commitID تغییر کرد
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
            },
          }
        );
        if (res?.data.amount_of_land) {
          setisLoadingBtnModal(false);
          setSelectedFarmerInfo({
            amount_of_land: res?.data?.amount_of_land || "", // اگر null بود، خالی برگردان
            village_name: res?.data?.village_name || "",
            date_set: res?.data?.date_set || "",
          });
        }
      } catch (error) {
        setisLoadingBtnModal(false);
        console.error("Error fetching farmer info:", error);
      }
    };
    getFarmerInfo();
  }, [coomitID]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get("https://api.havirkesht.ir/factory/", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setdataFactoryList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == localstorageID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = `https://api.havirkesht.ir/commitment/?sort_by=updated_at&sort_order=desc&crop_year_id=${localstorageID}`;
        if (SearchValueCommit && SearchValueCommit.trim() !== "") {
          url += `&search=${encodeURIComponent(SearchValueCommit.trim())}`;
        }
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setcommitment_idList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };
    fetchData();
  }, [SearchValueCommit]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        let url = "https://api.havirkesht.ir/pesticide/";
        // اضافه کردن پارامتر جستجو اگر وجود دارد
        if (searchpesticide && searchpesticide.trim() !== "") {
          const searchParams = new URLSearchParams();
          searchParams.append("search", searchpesticide.trim());
          url += `?${searchParams.toString()}`;
        }

        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setdataSeedList(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, [searchpesticide]);
  const formatNumber = (num: number | string) => {
    if (!num) return "";
    const numStr = num.toString().replace(/,/g, "");
    return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const parseFormattedNumber = (formattedNum: string) => {
    return formattedNum.replace(/,/g, "");
  };

  const handlerUpdate = (ele: any) => {
    setIsedit(true);
    console.log(ele);
    setShow(true);
    setcoomitID(ele?.commitment_id);
    setseednameForEdit(ele?.pesticide_name);
    setDataSeedID(ele?.pesticide_id);
    setidSeed(ele?.id);
    setseed_amount(ele?.pesticide_amount);
    setFactorynameUpdate(ele?.factory_name);
    setFarmerNameForEdit(ele.farmer_name);
    setdefultcheckedPrice(ele?.price > 0 ? false : true);
    setpoison_Price(ele?.price);
    setDataFactoryID(ele.factory_id);
  };

  const handleSelect = (value: number) => {
    setSelectedNumber(value); // ذخیره مقدار انتخابی
    const newSize = value;
    let newPage = currentPage;

    const totalItems = alldata ? Number(alldata) : 0;

    if (newPage > Math.ceil(totalItems / newSize)) {
      newPage = Math.max(1, Math.ceil(totalItems / newSize));
    }

    setsize(newSize); // تنظیم سایز جدید
    setCurrentPage(newPage); // تنظیم صفحه جدید

    // فراخوانی داده‌ها با سایز و صفحه تنظیم‌شده
    fetchData(newPage, newSize);
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    fetchData(currentPage, selectedNumber);
  }, [currentPage, size, reload, searchValue, sortState]);

  const fetchData = async (page: number, size: number) => {
    setisLoadingBtn(true);
    try {
      const base = "https://api.havirkesht.ir/farmers-pesticide/";
      const params = new URLSearchParams();

      params.set("size", String(size));
      params.set("page", String(page));
      if (localstorageID != null)
        params.set("crop_year_id", String(localstorageID));

      // فقط یک سرچ: اولویت با searchValue.trim()، بعد searchValue
      const term =
        (typeof searchValue === "string" && searchValue.trim()) ||
        (typeof searchValue === "string" && searchValue.trim()) ||
        "";
      if (term) params.set("search", term);

      // سورت هماهنگ با step
      if (sortState) {
        if (sortState.step === 2) {
          params.set("sort_by", "created_at");
          params.set("sort_order", "desc");
        } else {
          // step 0 یا 1
          const by = sortState.name || "updated_at";
          const order = sortState.order === "asc" ? "asc" : "desc";
          params.set("sort_by", by);
          params.set("sort_order", order);
        }
      }

      const url = `${base}?${params.toString()}`;
      
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("app_atkey")}`,
        },
      });

          setData(response.data.items);
      setalldata(response?.data?.total);
      setTotalPages(response?.data?.pages);
    } catch (error) {
      console.error("خطا در دریافت پرداخت‌ها:", error);
      toast.error("خطا در بارگذاری پرداخت‌ها");
    } finally {
      setisLoadingBtn(false);
    }
  };


  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.id) {
      setEventData(cell.id);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      try {
        const res = await axios.delete(
          `https://api.havirkesht.ir/farmers-pesticide/${eventData}`
        );
        if (res.status === 200) {
          Swal.fire({
            title: "حذف سم کشاورز",
            text: "عملیات حذف با موفقیت انجام شد",
            icon: "success",
          });
          setreload(!reload);
        } else {
          Swal.fire({
            title: "حذف سم کشاورز",
            text: "مشکلی در حذف به وجود امده است",
            icon: "error",
          });
        }
        setDeleteModal(false);
        setEventData(null);
      } catch (error) {
        toast.error("مشکل در حذف داده ");
      }
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      seed_amount: isEdit ? seed_amount : "",
      poison_Price: isEdit ? poison_Price : "",
    },
    validationSchema: Yup.object({
      seed_amount: Yup.number().required("لطفاً مقدار را وارد کنید"),
    }),
    onSubmit: async (values) => {
      setisLoadingBtn(true);
      if (values.seed_amount <= 0) {
        setShow(true);
        setisLoadingBtn(false);
        return toast.error("مقدار نمیتواند  صفر یا کمتر باشد");
      }
      if (isEdit) {
        const update = {
          pesticide_amount: values.seed_amount,
          commitment_id: coomitID,
          pesticide_id: dataSeedID,
          factory_id: dataFactoryID,
          crop_year_id: Number(localStorage.getItem("crop_year_id")),
          price: defultcheckedPrice ? null : Number(values.poison_Price),
          price_for_all_farmers_checkbox: defultcheckedPrice,
        };
        console.log(update);

        try {
          const res = await axios.put(
            `https://api.havirkesht.ir/farmers-pesticide/${Number(idSeed)}`,
            update
          );

          if (res.status === 200) {
            setisLoadingBtn(false);
            resetAllStates();
            return Swal.fire({
              title: "بروزرسانی سم کشاورز",
              text: "بروز رسانی سم کشاورز با موفقیت انجام شد",
              icon: "success",
            });
          }
          resetAllStates();
          setcoomitID(null);
          setIsedit(false);
          setseednameForEdit(null);
          setDataSeedID(null);
        } catch (error: any) {
          console.log(error, "error in update");
          if (error.status == 404) {
            setShow(true);
            setisLoadingBtn(false);
            return Swal.fire({
              title: "بروز رسانی سم کشاورز",
              text: " قیمت سم کارخانه برای کارخانه، سم و سال زراعی مشخص شده یافت نشد لطفا قیمت را وارد کنید",
              icon: "warning",
            });
          }
          // toast.error(y"خطا در بروزرسانی اطلاعات");
          setisLoadingBtn(false);
        }
      } else {
        if (!dataSeedID || !coomitID) {
          setShow(true);
          setisLoadingBtn(false);
          return toast.error("لطفا سم و  نام کشاورز را انتخاب کنید");
        }
        setisLoadingBtn(false);
        try {
          const newData = {
            pesticide_amount: values.seed_amount,
            commitment_id: coomitID,
            factory_id: dataFactoryID,
            pesticide_id: dataSeedID,
            price_for_all_farmers_checkbox: defultcheckedPrice,
            price: defultcheckedPrice ? 0 : Number(values.poison_Price),
            crop_year_id: Number(localStorage.getItem("crop_year_id")),
          };
          console.log(newData, "newData");
          const res = await axios.post(
            "https://api.havirkesht.ir/farmers-pesticide/",
            newData
          );

          const FarmerID = Number(res?.data?.id);
          await axios.post(
            `https://api.havirkesht.ir/sms/farmer-pesticide-notification/${FarmerID}`
          );
          if (res.status === 201) {
            setreload(!reload);
            Swal.fire({
              title: "ثبت سم کشاورز",
              text: "ثبت سم کشاورز با موفقیت انجام شد",
              icon: "success",
            });
            setreload(!reload);
            setisLoadingBtn(false);
            resetAllStates();
          }
          // resetAllStates();
        } catch (error: any) {
          console.log(error);
          if (error.status == 404) {
            setShow(true);
            return await Swal.fire({
              title: "ثبت سم کشاورز",
              text: " قیمت سم کارخانه برای کارخانه، سم و سال زراعی مشخص شده یافت نشد لطفا قیمت را وارد کنید",
              icon: "warning",
            });
          }
          setreload(!reload);
          console.log(error);
          Swal.fire({
            title: "ثبت سم کشاورز",
            text: "مشکلی پیش امده لطفا مجددا تلاش کنید",
            icon: "error",
          });
          // toast.error("خطا در ثبت اطلاعات");
          setisLoadingBtn(false);
        }
      }
      toggle();
    },
  });

  function resetAllStates() {
    setreload(!reload);
    setShow(false);
    setselectedCommitment(null);
    setidSeed(null);
    setcoomitID(null);
    setIsedit(false);
    setseednameForEdit(null);
    setDataSeedID(null);
    setseed_amount(null);
    setDataFactoryID(null);
    validation.resetForm();
  }

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      resetAllStates();
      setIsedit(false);
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columnName = (name: string) => {
    setSortState((prev: any) => {
      if (prev.name === name) {
        // اگر روی همان ستون کلیک شد
        const nextStep = (prev.step + 1) % 3; // چرخه بین 0، 1 و 2
        if (nextStep === 0) {
          return { name, order: "desc", step: 0 }; // حالت اول: نزولی
        } else if (nextStep === 1) {
          return { name, order: "asc", step: 1 }; // حالت دوم: صعودی
        } else {
          return { name: "created_at", order: "desc", step: 2 }; // حالت سوم: تاریخ ایجاد نزولی
        }
      } else {
        // اگر ستون جدیدی انتخاب شد
        return { name, order: "desc", step: 0 }; // شروع با حالت نزولی
      }
    });
    setreload(!reload);
  };
  const resetSorting = () => {
    setSortState({
      name: null,
      order: "desc",
      step: 0,
    });
    setreload(!reload);
  };
  const columns = PesticideFarmerColumn({
    onClickDelete,
    handlerUpdate,
    columnName,
  });
  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت سم کشاورز" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="flex w-96"></div>
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center flex-col md:flex-row gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع سم کشاورز (
              <b className="total-Employs">{alldata?.toString()}</b>)
              <label className="flex flex-col gap-2 mt-4 sm:flex-row sm:items-center">
                <span className="whitespace-nowrap p-1">جست‌وجو:</span>
                <div className="relative w-full sm:w-64">
                  <input
                    type="text"
                    className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
                    placeholder="جستجو..."
                    value={searchValue}
                    onChange={(e) => setsearchValue(e.target.value)}
                  />
                  <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
                    {searchValue ? (
                      <X
                        size={15}
                        className="cursor-pointer"
                        onClick={() => setsearchValue("")}
                      />
                    ) : (
                      <SearchIcon size={15} />
                    )}
                  </span>
                </div>
              </label>
            </h6>
            <div className="w-full sm:w-auto">
              <TableDropDownSmall onSelect={handleSelect} />
            </div>
            <div className="shrink-0">
              <Link
                to=""
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl"> ثبت سم کشاورز </span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
              <Link
                to="/placed-farmer"
                type="button"
                className="text-white btn mr-2 bg-green-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">بازگشت </span>{" "}
                <ArrowLeft className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {sortState.name && (
            <div className="gap-1 mb-2 items-center flex">
              <X
                size={16}
                className="text-red-600 cursor-pointer"
                onClick={resetSorting}
              />
              مرتب‌سازی بر اساس:{" "}
              {sortState.step === 2
                ? ` (تاریخ ایجاد)`
                : `${sortLabels[sortState.name]} ${
                    sortState.order === "asc" ? "(صعودی)" : "(نزولی)"
                  }`}
            </div>
          )}
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={false}
              columns={columns}
              isGlobalFilter={false}
              customnumberfortable={12}
              data={data}
              customPageSize={selectedNumber}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
          {/* صفحه‌بندی */}
          <PaginationTest
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
      <PoisonFarmerModal
        show={show}
        setsearchpesticide={setsearchpesticide}
        isEdit={isEdit}
        onHide={toggle}
        onSubmit={handleClick}
        validation={validation}
        selectedCommitment={selectedCommitment}
        setSelectedCommitment={setselectedCommitment}
        setcoomitID={setcoomitID}
        coomitID={coomitID}
        setsetSearchValueCommit={setsetSearchValueCommit}
        commitment_idList={commitment_idList}
        FarmerNameForEdit={FarmerNameForEdit}
        isLoadingBtnModal={isLoadingBtnModal}
        selectedFarmerInfo={selectedFarmerInfo}
        dataSeedID={dataSeedID}
        setDataSeedID={setDataSeedID}
        dataSeedList={dataSeedList}
        seednameForEdit={seednameForEdit}
        dataFactoryID={dataFactoryID}
        setDataFactoryID={setDataFactoryID}
        dataFactoryList={dataFactoryList}
        FactorynameUpdate={FactorynameUpdate}
        defultcheckedPrice={defultcheckedPrice}
        setdefultcheckedPrice={setdefultcheckedPrice}
        YearCoptSelect={YearCoptSelect}
        isLoadingBtn={isLoadingBtn}
        formatNumber={formatNumber}
        parseFormattedNumber={parseFormattedNumber}
      />
    </React.Fragment>
  );
};

export default PoisonDeliveryFarmer;
